__turbopack_context__.v({
  "className": "oswald_31eab7d6-module__7YlZ1q__className",
});
